function FeaturedSection(props: any) {
	const { children } = props;
	return <section id="featured-section">{children}</section>;
}

export default FeaturedSection;
